import { createContext, __DEV__ } from '../../utils';
import * as React from 'react';
var [PortalManagerContextProvider, usePortalManager] = createContext({
  strict: false,
  name: 'PortalManagerContext'
});
export { usePortalManager };
export function PortalManager(props) {
  var {
    children,
    zIndex
  } = props;
  return /*#__PURE__*/React.createElement(PortalManagerContextProvider, {
    value: {
      zIndex
    }
  }, children);
}
if (__DEV__) {
  PortalManager.displayName = 'PortalManager';
}